"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SubMenu = exports.MenuItem = exports.Menu = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("../../util/hooks");

var _classNames = _interopRequireDefault(require("../../util/classNames"));

require("./MenuBar.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var MenuBar = function MenuBar(_ref) {
  var onSelect = _ref.onSelect,
      children = _ref.children;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var toggle = function toggle() {
    return setOpen(!isOpen);
  };

  var handleSelect = function handleSelect(e) {
    setTimeout(function () {
      return setOpen(false);
    }, 300);
    onSelect(e.target.id);
  };

  return /*#__PURE__*/_react["default"].createElement("nav", {
    className: 'gcl-menubar' + (isOpen ? ' open' : ''),
    role: "menu"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "gcl-menubar-toggle",
    onClick: toggle
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon menu"
  }), "Menu"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-menu-container"
  }, /*#__PURE__*/_react["default"].createElement("header", null, /*#__PURE__*/_react["default"].createElement("h4", null, "Menu"), /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon close clickable",
    onClick: toggle
  })), Array.isArray(children) ? children.map(function (child, i) {
    return /*#__PURE__*/_react["default"].cloneElement(child, {
      key: i,
      onSelect: handleSelect
    });
  }) : /*#__PURE__*/_react["default"].cloneElement(children, {
    onSelect: handleSelect
  })));
};

var Menu = function Menu(_ref2) {
  var label = _ref2.label,
      onSelect = _ref2.onSelect,
      children = _ref2.children;

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isOpen = _useState4[0],
      setOpen = _useState4[1];

  var toggle = function toggle() {
    return setOpen(!isOpen);
  };

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      selected = _useState6[0],
      setSelected = _useState6[1];

  var wrapperRef = (0, _react.useRef)(null);
  (0, _hooks.useOutsideClick)(wrapperRef, function () {
    return setTimeout(function () {
      return setOpen(false);
    }, 300);
  });

  var handleSelect = function handleSelect(e) {
    setSelected(true);
    setTimeout(function () {
      setOpen(false);
      setSelected(false);
    }, 600);
    onSelect(e);
  };

  var _useScaledRightLimit = (0, _hooks.useScaledRightLimit)(),
      _useScaledRightLimit2 = _slicedToArray(_useScaledRightLimit, 2),
      menuRef = _useScaledRightLimit2[0],
      right = _useScaledRightLimit2[1];

  var classes = (0, _classNames["default"])({
    show: isOpen,
    hide: selected,
    'right-aligned': right
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-menu",
    ref: wrapperRef
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-menu-toggle",
    onClick: toggle
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "gcl-menu-label"
  }, label), /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon chevron-right"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    ref: menuRef,
    className: 'gcl-menu-list gcl-fader on-parent-hover with-delay ' + classes
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    onClick: toggle
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon chevron-left"
  }), label), children && /*#__PURE__*/_react["default"].createElement("ul", null, Array.isArray(children) ? children.map(function (child, i) {
    return /*#__PURE__*/_react["default"].cloneElement(child, {
      key: i,
      onClick: handleSelect
    });
  }) : /*#__PURE__*/_react["default"].cloneElement(children, {
    onClick: handleSelect
  }))));
};

exports.Menu = Menu;

var MenuItem = function MenuItem(_ref3) {
  var id = _ref3.id,
      onClick = _ref3.onClick,
      children = _ref3.children;

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      submenuOpen = _useState8[0],
      setSubmenuOpen = _useState8[1];

  var ref = (0, _react.useRef)(null);
  (0, _hooks.useOutsideClick)(ref, function () {
    return setSubmenuOpen(false);
  });
  var hasSubMenu = Array.isArray(children);
  return /*#__PURE__*/_react["default"].createElement("li", {
    id: id,
    ref: ref,
    className: 'gcl-menuitem' + (hasSubMenu ? ' submenu' : ''),
    onClick: hasSubMenu ? function () {
      return setSubmenuOpen(!submenuOpen);
    } : onClick
  }, hasSubMenu ? children.map(function (child, i) {
    return /*#__PURE__*/_react["default"].isValidElement(child) ? /*#__PURE__*/_react["default"].cloneElement(child, {
      key: i,
      onSelect: onClick,
      isOpen: submenuOpen
    }) : child;
  }) : children);
};

exports.MenuItem = MenuItem;

var SubMenu = function SubMenu(_ref4) {
  var isOpen = _ref4.isOpen,
      onSelect = _ref4.onSelect,
      children = _ref4.children;

  var _useScaledRightLimit3 = (0, _hooks.useScaledRightLimit)(),
      _useScaledRightLimit4 = _slicedToArray(_useScaledRightLimit3, 2),
      menuRef = _useScaledRightLimit4[0],
      right = _useScaledRightLimit4[1];

  var classes = (0, _classNames["default"])({
    'touch-show': isOpen,
    'right-aligned': right
  });
  return /*#__PURE__*/_react["default"].createElement("ul", {
    ref: menuRef,
    className: 'gcl-submenu gcl-fader on-parent-hover with-delay ' + classes
  }, Array.isArray(children) ? children.map(function (child, i) {
    return /*#__PURE__*/_react["default"].cloneElement(child, {
      key: i,
      onClick: onSelect
    });
  }) : /*#__PURE__*/_react["default"].cloneElement(children, {
    onClick: onSelect
  }));
};

exports.SubMenu = SubMenu;
MenuBar.propTypes = {
  onSelect: _propTypes["default"].func.isRequired
};
var _default = MenuBar;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/MenuBar/MenuBar.js
// module id = 1908
// module chunks = 0